import "/src/hero/index.js";
import "/src/latest-posts/index.js";
import "/src/latest-blogs/index.js";
import "/src/section-actuality/index.js";
import "/src/block-short-links/index.js";
import "/src/section-reviews/index.js";
import "/src/section-our-favourites/index.js";
import "/src/post-block-pros-and-cons/index.js";
import "/src/post-pink-block-text/index.js";
import "/src/block-product/index.js";
import "/src/section-most-viewed/index.js";
import "/src/rolling-banner/index.js";
import "/src/block-instagram-feed/index.js";
import "/src/block-product-external/index.js";

/* Disabled blocks
import "/src/product-review-block/index.js";
*/